import { defaultH2Style } from "./style-constants";

import { BaseTooltipModel } from "./base-tooltip-model";

import { ShapeModel } from "./shape-model";

import { TextModel } from "./text-model";

import { mergeSpec } from "@visactor/vutils-extension";

export class TitleModel extends BaseTooltipModel {
    init() {
        const tooltipActual = this._option.getTooltipActual();
        this.product || (this.product = this.createElement("h2"));
        const {align: align} = this._option.getTooltipAttributes();
        "right" !== align || this.textSpan || this._initTextSpan(0);
        const {title: title} = tooltipActual;
        (null == title ? void 0 : title.hasShape) && (null == title ? void 0 : title.shapeType) ? this.shape || this._initShape("right" === align ? 1 : 0) : this.shape && this._releaseShape(), 
        "right" === align || this.textSpan || this._initTextSpan(1);
    }
    _initShape(index = 0) {
        const shape = new ShapeModel(this.product, this._option, index);
        shape.init(), this.shape = shape, this.children[shape.childIndex] = shape;
    }
    _releaseShape() {
        this.shape && (this.shape.release(), delete this.children[this.shape.childIndex], 
        this.shape = null);
    }
    _initTextSpan(index = 1) {
        const textSpan = new TextModel(this.product, this._option, index);
        textSpan.init(), this.textSpan = textSpan, this.children[textSpan.childIndex] = textSpan;
    }
    setStyle(style) {
        var _a, _b, _c, _d;
        const tooltipStyle = this._option.getTooltipStyle(), tooltipActual = this._option.getTooltipActual(), {title: title} = tooltipActual;
        super.setStyle(mergeSpec({}, defaultH2Style, tooltipStyle.title, style)), null === (_a = this.shape) || void 0 === _a || _a.setStyle({
            paddingRight: null === (_b = tooltipStyle.shapeColumn.common) || void 0 === _b ? void 0 : _b.marginRight
        }, {
            hasShape: null == title ? void 0 : title.hasShape,
            symbolType: null == title ? void 0 : title.shapeType,
            size: null === (_c = tooltipStyle.shapeColumn.common) || void 0 === _c ? void 0 : _c.width,
            fill: null == title ? void 0 : title.shapeColor,
            hollow: null == title ? void 0 : title.shapeHollow
        }), null === (_d = this.textSpan) || void 0 === _d || _d.setStyle({
            color: "inherit"
        });
    }
    setContent() {
        var _a, _b, _c, _d, _e, _f;
        const tooltipStyle = this._option.getTooltipStyle(), tooltipActual = this._option.getTooltipActual(), tooltipAttributes = this._option.getTooltipAttributes(), {title: title} = tooltipActual;
        this.init(), null === (_a = this.shape) || void 0 === _a || _a.setStyle(void 0, {
            hasShape: null == title ? void 0 : title.hasShape,
            symbolType: null == title ? void 0 : title.shapeType,
            size: null === (_b = tooltipStyle.shapeColumn.common) || void 0 === _b ? void 0 : _b.width,
            fill: null == title ? void 0 : title.shapeColor,
            hollow: null == title ? void 0 : title.shapeHollow
        }), null === (_c = this.textSpan) || void 0 === _c || _c.setStyle({
            color: "inherit"
        }), null === (_d = this.textSpan) || void 0 === _d || _d.setContent(null == title ? void 0 : title.value, null === (_f = null === (_e = tooltipAttributes.title) || void 0 === _e ? void 0 : _e.value) || void 0 === _f ? void 0 : _f.multiLine);
    }
    release() {
        super.release(), this.shape = null, this.textSpan = null;
    }
}
//# sourceMappingURL=title-model.js.map
